import { render, staticRenderFns } from "./batchCreatePage.vue?vue&type=template&id=02714be2&scoped=true"
import script from "./batchCreatePage.vue?vue&type=script&lang=js"
export * from "./batchCreatePage.vue?vue&type=script&lang=js"
import style0 from "./batchCreatePage.vue?vue&type=style&index=0&id=02714be2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02714be2",
  null
  
)

export default component.exports